// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"5a4c57c0","701":"5a4c57c0","803":"5aedf711"}[chunkId] + ".css";
};